import { checkPaymentRequired } from '../../../common/licenseUtils';
import { RootState } from 'src/store/store';

export const selectRenewalPermitData = (state: RootState) =>
  state.renew?.applicationData;
export const selectInitiatingRenewFlow = (state: RootState) =>
  state.renew?.initiatingRenewFlow;
export const selectInitiatingRenewFlowError = (state: RootState) =>
  state.renew?.initiatingRenewFlowError;
export const selectPermitRegistrant = (state: RootState) =>
  state.renew?.applicationData?.registrant;
export const selectRenewLicenseInProgress = (state: RootState) =>
  state.renew.renewLicenseInProgress;
export const selectRenewLicenseError = (state: RootState) =>
  state.renew.renewLicenseError;
export const selectDocumentUploadErrors = (state: RootState) =>
  state.renew?.documentUploadErrors;
export const selectRenewApplicationNumber = (state: RootState) =>
  state.renew?.applicationNumber;
export const selectRenewIsPaymentRequired = (state: RootState) =>
  checkPaymentRequired(state.config?.settings?.express?.registration?.renew);

export const selectLateRenewalData = (state: RootState) =>
  state.renew?.lateRenewalData;
export const selectSelectedBulkRenewalLicenses = (state: RootState) =>
  state.renew?.selectedBulkRenewalLicenses;
